import * as React from 'react'

export interface BannerContextValue {
  size: 'M' | 'S'
}

export const BannerContext = React.createContext<BannerContextValue>({ size: 'M' })
